import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CheckboxComponent, IconComponent, NgTemplateOutlet, NgClass, NgStyle],
  styles: [],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent {
  alerts = [
    {
      date: '20 min ago',
      header: 'CIS Log Verification',
      html: `<div>2 of 2 users verified <a class="aux-link" href="#">CIS Log Item #5</a> for Vendor Contract #2 in trial AJ-156-7A</div>`,
    },
    {
      date: '1 day ago',
      header: 'Risk Alert',
      html: `<div><a class="aux-link" href="#">Risk Analytics</a> changed in site health for two sites, Columbia Presbyterian and Colorado University</div>`,
    },
    {
      date: '2 days ago',
      header: 'Accrual Drivers Change',
      html: `<div><a class="aux-link" href="#">Drivers</a> were updated on the patients tab for trial AJ-156-7A</div>`,
    },
    {
      date: '5 days ago',
      header: 'New Change Order Added',
      html: `<div><a class="aux-link" href="#">WO Amendment #3</a> was added for Vendor Contract #1 in trial AJ-156-7A</div>`,
    },
  ];
  percentage = 80;
  timelineData = [
    {
      header: 'Trial 1, Vendor Contract 1',
      leftLabel: 'WP: 12%',
      progressColor: 'blue',
      rightLabel: 'Total Budget: $2.6mm',
      value: 20,
    },
    {
      header: 'Trial 1, Vendor Contract 2',
      leftLabel: 'WP: 52%',
      progressColor: 'blue',
      rightLabel: 'Trial Budget: $450,000',
      value: 50,
    },
    {
      header: 'Trial 1, Vendor Contract 3',
      leftLabel: 'WP: 0%',
      progressColor: 'blue',
      rightLabel: 'Trial Budget: $230,000',
      value: 5,
    },
  ];
}
